// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2QqDK","type":"styles_type__4NENg","choices":"styles_choices___McIL"};